import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import CasesContent from './components/CasesContent';

export default function CasesPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '成功案例｜保健食品 ODM OEM 品牌合作實例｜康永生技',
    description: '康永生技 ODM 成功案例：美妝保養、寵物健康、兒童營養、電台聯名、農特產聯名等多元品類代工實績。250+ 服務品牌數、3,200+ 累積代工品項。',
    keywords: '成功案例,ODM案例,OEM案例,品牌合作實例,保健食品代工案例,康永案例',
    lang: 'zh-TW',
    canonicalPath: '/about/cases',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="成功案例｜保健食品 ODM OEM 品牌合作實例｜康永生技" pageDescription="康永生技 ODM 成功案例：美妝保養、寵物健康、兒童營養、電台聯名、農特產聯名等多元品類代工實績。250+ 服務品牌數、3,200+ 累積代工品項。" pageUrl={`${siteUrl}/about/cases`} />
      <CasesContent />
    </Layout>
  );
}